import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient } from '@angular/common/http';
// import { promise } from 'protractor';

@Injectable({
  providedIn: 'root',
})
export class ProjetoService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }
  listar(filtro) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/Listar',
          filtro,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }
  visualizar(model) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/projetovisualizadousuario/criar',
          model,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }

  listarDocumentos(id) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/ListarDocumentos',
          id,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }

  obterPctChanceAprovacao(id) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/ObterPctChanceAprovacao?idProjeto=' +
            id,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }

  listarBolha(idProjetoLista) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/listarBolha',
          idProjetoLista,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }
  bolhaRecente() {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/bolhaRecente',
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }
  inserirProposicaoIgnorada(model) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/inserirProposicaoIgnorada',
          model,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }
  obterTextoInteiroTeor(idProjeto) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/InteiroTeor/ObterTexto?idProjeto=' +
            idProjeto
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }
  listarRadar(idProjeto, idUsuario) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/ListarRadar?idProjeto=' +
            idProjeto +
            '&idUsuario=' +
            idUsuario,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }

  listarRelacionadas(idProjeto) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/Relacionados?IdProjeto=' +
            idProjeto,
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          },
        );
    });
  }

  obter(filtro, error = null) {
    if (!error)
      error = (error) => {
        //alert(
        //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
        //);
      };
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/Obter',
          filtro,
        )
        .subscribe((data) => {
          resolve(data);
        }, error);
    });
  }
  resumoExecutivo(textoObj) {
    return new Promise(async (resolve) => {
      this.http
        .post(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/ResumoExecutivo',
          textoObj,
        )
        .subscribe((data) => {
          resolve(data);
        });
    });
  }
  excel(model) {
    var query = new URLSearchParams();
    model.IdProjetoLista.forEach((element) => {
      query.append('id', element);
    });
    return (
      'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/excel?nome=' +
      model.Nome +
      '&' +
      query.toString()
    );
  }
  listarPorTituloECasa(model) {
    var query = new URLSearchParams();
    model.tituloLista.forEach((element) => {
      query.append('tituloLista', element);
    });
    var url =
      'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/ListarPorTituloECasa?idCategoria=' +
      model.IdCategoria +
      '&' +
      query.toString();
    return new Promise(async (resolve) => {
      this.http.get(url).subscribe((data) => {
        resolve(data);
      });
    });
  }

  pdf(model) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/pdf?idUsuario=' +
            model.IdUsuario +
            '&id=' +
            model.IdProjeto,
        )
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  listarProposicaoIgnorada(idRadar) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/ListarProposicaoIgnorada?idRadar=' +
            idRadar,
        )
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  termometro(idProjeto) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/Termometro?IdProjeto=' +
            idProjeto,
        )
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  count(idProjetoLista) {
    var query = new URLSearchParams();
    return new Promise(async (resolve) => {
      idProjetoLista.forEach((element) => {
        query.append('idProjetoLista', element);
      });
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/count?' +
            query.toString(),
        )
        .subscribe((data) => {
          resolve(data);
        });
    });
  }

  listarPloa() {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/ProjetoLei/listarPloa',
        )
        .subscribe((data) => {
          resolve(data);
        });
    });
  }
}
